import '../style.css';
import React, { useState } from 'react';
import { Button, Grid, List, ListItemButton, Paper, styled, Table, TableBody, TableCell, tableCellClasses, TableContainer, TableHead, TableRow, TextField, Typography } from '@mui/material';
import { RefreshRounded } from '@mui/icons-material';
import { forceMenuScan, getMenu, getMenuLocations, getMenuScanStatus } from '../common/api';

class Restaurant {
  id: number;
  name: string;
  cityState?: string;
  url: string;
}


type RestarauntDataProps = {
  restaurant: Restaurant;
  refreshCounter?: number;
}


export default function PlatelyMenuScrape() {


  //const [error, seError] = React.useState<string>('');


  const [restId, setRestId] = React.useState<number>(0);
  const [locList, setLocList] = useState<any[]>();
  const [searchTerm, setSearchTerm] = useState<string>('');

  const selRestaurant = locList?.find((r) => r.id == restId);

  if (!locList) {
    getMenuLocations().then((data) => {
      setLocList(data);
    });
  }
  console.log('Selecting...')

  const selectLocation = (id: number) => {
    console.log('Selected: ' + id);
    setRestId(id);
  }

  console.log(`Search term: ${searchTerm}`);

  const includeSearchItem = (item: Restaurant) => {
    if (searchTerm == '') {
      return true;
    }
    return item.name.toLowerCase().includes(searchTerm) ||
      item.cityState?.toLowerCase().includes(searchTerm);
  }

  return (
    <div style={{ minHeight: 400, maxWidth: 1800, marginLeft: 'auto', marginRight: 'auto', paddingTop: 14 }}>


      <Grid container >
        <Grid xs={6} md={3} textAlign={'center'} padding={1} gap={1}>
          <Grid container>
            <Grid xs={10} textAlign={'left'}>
              <Typography fontSize={18} fontWeight={'bold'}>Restaurants</Typography>
            </Grid>
            <Grid xs={2}>
              {/* <Button fullWidth variant={'contained'} onClick={addRest}>Add...</Button> */}
            </Grid>
            <Grid xs={12}>
              <TextField fullWidth label={'Search...'} variant={'outlined'} onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                setSearchTerm(event.target.value.toLowerCase());
              }} />
            </Grid>
          </Grid>

          <List sx={{
            width: '100%',
            maxWidth: 360,
            bgcolor: 'background.paper',
            position: 'relative',
            overflow: 'auto',
            maxHeight: 800
          }}>
            {
              locList?.filter(includeSearchItem).map((restaurant: Restaurant) => (
                <ListItemButton selected={restId == restaurant.id} onClick={() => selectLocation(restaurant.id)} key={restaurant.id} >{restaurant.name + (restaurant.cityState ? '    - ' + restaurant.cityState : '')}</ListItemButton>
              ))
            }
          </List>
        </Grid>
        <Grid xs={6} md={9} padding={1} gap={1}>
          <RestarauntCard restaurant={selRestaurant} />

        </Grid>


      </Grid>

    </div>
  );
}

function RestarauntCard(props: RestarauntDataProps) {

  type ScanData = {
    counter: number,
    locationId: number
  }

  const [data, setData] = useState<ScanData>({
    counter: 0,
    locationId: 0
  });

  const incrementCounter = () => {
    setData({ ...data, counter: data.counter + 1 });
  }

  const startRescrape = (deleteExisting: boolean) => {
    console.log('Re-scraping restaurant: ' + props.restaurant?.id);
    forceMenuScan(props.restaurant?.id, deleteExisting).then((msg) => {
      console.log(msg);
      incrementCounter();
    }
    );
  }

  if (data.locationId != props.restaurant?.id && props.restaurant?.id) {
    console.log('Fetching restaurant: ' + props.restaurant?.id);
    setTimeout(() => {
      setData({ counter: data.counter + 1, locationId: props.restaurant?.id });
    }, 50);
  }

  console.log(`Refresh Counter: ${data.counter}`);

  return (
    <Grid color={'black'} container gap={1} padding={1} >

      <Grid xs={2}>
        <Typography fontSize={18} fontWeight={'bold'}>{props.restaurant?.name}</Typography>
      </Grid>
      <Grid xs={8}>
        <Typography fontSize={18} fontWeight={'bold'}>{props.restaurant?.cityState ?? ''}</Typography>
      </Grid>
      <Grid xs={1}>
        <Button variant={'contained'} onClick={incrementCounter}><RefreshRounded /></Button>
      </Grid>
      <Grid xs={12}>
        <RestaurauntStatusCard restaurant={props.restaurant} refreshCounter={data.counter} />
      </Grid>
      <Grid xs={2} textAlign={'left'}>
        <Typography fontSize={18} fontWeight={'bold'}>Menu</Typography>
      </Grid>
      <Grid xs={4}>
        <Button fullWidth variant={'contained'} onClick={() => startRescrape(true)}>DELETE MENU</Button>
      </Grid>
      <Grid xs={4}>
        <Button fullWidth variant={'contained'} onClick={() => startRescrape(false)}>SCRAPE NOW</Button>
      </Grid>
      <Grid xs={12}>
        <RestaurauntMenuCard restaurant={props.restaurant} refreshCounter={data.counter} />
      </Grid>

    </Grid>
  )

}


function RestaurauntStatusCard(props: RestarauntDataProps) {

  type ScanStatus = {
    refreshCounter: number;
    locationId: number;
    inProgress: boolean;
    requestDate?: Date;
    lastScanDate?: Date;
    lastScanStatus: string;
    lastScanError: string;
  }

  const [data, setStatus] = useState<ScanStatus>({
    refreshCounter: -1,
    locationId: 0,
    inProgress: false,
    requestDate: undefined,
    lastScanDate: undefined,
    lastScanStatus: '',
    lastScanError: ''

  });

  if (data.refreshCounter != props.refreshCounter) {
    console.log('Fetching status for restaurant: ' + props.restaurant?.id);
    getMenuScanStatus(props.restaurant?.id).then((data) => {
      setStatus({ ...data, refreshCounter: props.refreshCounter });
    });

    return (
      <Grid color={'black'} padding={1} container border={1} sx={{ backgroundColor: '#fef9e7' }}>
        <Grid xs={2} >
          <Typography align='left' fontSize={16} >Status:</Typography>
        </Grid>
        <Grid xs={10}>
          <Typography align='left' fontSize={16} fontWeight={'bold'}></Typography>
        </Grid>
        <Grid xs={2}>
          <Typography align='left' fontSize={16} >Last Scan:</Typography>
        </Grid>
        <Grid xs={10}>
          <Typography align='left' fontSize={16} fontWeight={'bold'}></Typography>
        </Grid>
        <Grid xs={2}>
          <Typography align='left' fontSize={16} >Details:</Typography>
        </Grid>
        <Grid xs={10}>
          <Typography align='left' fontSize={16} fontWeight={'bold'}></Typography>
        </Grid>
        <Grid xs={10}> </Grid>

      </Grid>);
  }

  return (
    <Grid color={'black'} padding={1} container border={1} sx={{ backgroundColor: '#fef9e7' }}>
      <Grid xs={2} >
        <Typography align='left' fontSize={16} >Status:</Typography>
      </Grid>
      <Grid xs={10}>
        <Typography align='left' fontSize={16} fontWeight={'bold'}>{data.inProgress ? 'Scanning...' : 'Finished'}</Typography>
      </Grid>
      <Grid xs={2}>
        <Typography align='left' fontSize={16} >Last Scan:</Typography>
      </Grid>
      <Grid xs={10}>
        <Typography align='left' fontSize={16} fontWeight={'bold'}>{data.lastScanDate ? (new Date(data.lastScanDate).toLocaleDateString() + '  ' + new Date(data.lastScanDate).toLocaleTimeString()) : ''} {'[' + data.lastScanStatus + ']'}</Typography>
      </Grid>
      <Grid xs={2}>
        <Typography align='left' fontSize={16} >Details:</Typography>
      </Grid>
      <Grid xs={10}>
        <Typography align='left' fontSize={16} fontWeight={'bold'}>{data.lastScanError}</Typography>
      </Grid>
      <Grid xs={10}> </Grid>

    </Grid>
  );

}

function RestaurauntMenuCard(props: RestarauntDataProps) {

  type RestData = {
    locationId: number,
    refreshCounter: number
  }


  const [selTab, setSelTab] = useState<number>(0);
  const [data, setMenu] = useState<any[]>([]);
  const [lastLoc, setLoc] = useState<RestData>({
    locationId: 0,
    refreshCounter: -1
  });

  if (lastLoc.refreshCounter != props.refreshCounter) {
    console.log('Fetching menu for restaurant: ' + props.restaurant?.id);
    getMenu(props.restaurant?.id).then((data) => {
      setMenu(data);
      setLoc({
        locationId: props.restaurant?.id,
        refreshCounter: props.refreshCounter
      });
    }
    );

    return (
      <div>Loading...</div>
    )
  }

  const typeToTab = [
    1, 2, 3, 4, 5, 9
  ]

  const tabCounts = [0, 0, 0, 0, 0, 0];

  for (let i = 0; i < data.length; i++) {
    tabCounts[i] = data.filter((item) => typeToTab[i] == item.itemTypeId).length;
  }

  // eslint-disable-next-line @typescript-eslint/naming-convention
  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: theme.palette.common.black,
      color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
    },
  }));

  return (

    <Grid container >
      <Grid xs={6} md={2} border={'thin'}>
        <Button fullWidth variant={selTab == 0 ? 'contained' : 'outlined'} onClick={() => setSelTab(0)}>Appetizers {'('}{tabCounts[0]}{')'}</Button>
      </Grid>
      <Grid xs={6} md={2} border={'thin'}>
        <Button fullWidth variant={selTab == 1 ? 'contained' : 'outlined'} onClick={() => setSelTab(1)}>Beverages {'('}{tabCounts[1]}{')'}</Button>
      </Grid>
      <Grid xs={6} md={2} border={'thin'}>
        <Button fullWidth variant={selTab == 2 ? 'contained' : 'outlined'} onClick={() => setSelTab(2)}>Entrees {'('}{tabCounts[2]}{')'}</Button>
      </Grid>
      <Grid xs={6} md={2} border={'thin'}>
        <Button fullWidth variant={selTab == 3 ? 'contained' : 'outlined'} onClick={() => setSelTab(3)}>Sides {'('}{tabCounts[3]}{')'}</Button>
      </Grid>
      <Grid xs={6} md={2} border={'thin'}>
        <Button fullWidth variant={selTab == 4 ? 'contained' : 'outlined'} onClick={() => setSelTab(4)}>Desserts {'('}{tabCounts[4]}{')'}</Button>
      </Grid>
      <Grid xs={6} md={2} border={'thin'}>
        <Button fullWidth variant={selTab == 5 ? 'contained' : 'outlined'} onClick={() => setSelTab(5)}>Other {'('}{tabCounts[5]}{')'}</Button>
      </Grid>
      <Grid xs={12} padding={1}>

        <TableContainer component={Paper}>
          <Table sx={{ minWidth: 650 }} size="small" aria-label="a dense table">
            <TableHead>
              <TableRow>
                <StyledTableCell>Name</StyledTableCell>
                <StyledTableCell>Description</StyledTableCell>
                <StyledTableCell align="right">Price</StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {data.filter((item) => typeToTab[selTab] == item.itemTypeId).sort((a, b) => (a.name > b.name) ? 1 : -1).map((item) => (
                <TableRow
                  key={item.id}
                >
                  <TableCell component="th" scope="row" sx={{ fontWeight: 'bold' }}>
                    {item.name}
                  </TableCell>
                  <TableCell>{item.description}</TableCell>
                  <TableCell align="right">{item.price}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Grid>

      {/* <Grid xs={6} md={2} border={'thin'}>
          <Button fullWidth variant={selTab == 2 ? 'contained' : 'outlined'} onClick={() => setSelTab(2)}>Do Something Else</Button>
        </Grid> */}
    </Grid>


  );

}